import { Directive, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appDropdown]'
})
export class AppDropdownDirective implements OnInit {
  protected navlinks: Array<DropdownLinkDirective> = [];


    public closeOtherLinks(openLink: DropdownLinkDirective): void {
      this.navlinks.forEach((link: DropdownLinkDirective) => {
        if (link !== openLink) {
          link.open = false;
        }
      });
    }

    public addLink(link: DropdownLinkDirective): void {
      this.navlinks.push(link);
    }

    public removeGroup(link: DropdownLinkDirective): void {
      const index = this.navlinks.indexOf(link);
      if (index !== -1) {
        this.navlinks.splice(index, 1);
      }
    }

    public getUrl() {
      return this.router.url;
    }

    public ngOnInit(): any {
    }

    constructor( private router: Router) {}

}
